// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/header-image.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerDiv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 730px;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.titleDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 85px;
  color: #FDFDFD;
}

.quoteDiv {
  background-color: #F27400;
  color: white;
  height: 40px;
  width: 203px;
  font-size: 25px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.mainTitle {
  font-size: 60px;
  text-align: center;
  color: #FDFDFD;
  background-color: #F27400;
  padding: 8px 24px;
  margin: -24px;
  margin-bottom: auto;
}

.weCare {
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #F27400;
  color: #FDFDFD;
  position: absolute;
  top: 710px;
  font-weight: 500;
  height: 55px;
  padding: 16px;
  align-items: center;
  justify-content: center;
}

@media (max-width: 425px) {
  .headerDiv {
    background-attachment: unset;
    width: 231%;
  }

  .titleDiv {
    padding: 60px;
  }

  .weCare {
    width: 220%;
    height: 59px;
    top: 659px;
    font-size: 17px;
    left: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/Header.scss","webpack://./src/CSS/_variables.scss"],"names":[],"mappings":"AAEA;EACI,yDAAA;EACA,aAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,cCnBQ;ADkBZ;;AAKA;EACI,yBC1BY;ED2BZ,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFJ;;AAKA;EACI,eAAA;EACA,kBAAA;EACA,cCvCQ;EDwCR,yBC1CY;ED2CZ,iBAAA;EACA,aAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBCpDY;EDqDZ,cCnDQ;EDoDR,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;;AAKA;EAEA;IACI,4BAAA;IACA,WAAA;EAHF;;EAMF;IACI,aAAA;EAHF;;EAMF;IACI,WAAA;IACA,YAAA;IACA,UAAA;IACA,eAAA;IACA,UAAA;EAHF;AACF","sourcesContent":["@import \"./variables\";\n\n.headerDiv{\n    background-image: url(\"../images/header-image.jpeg\");\n    height: 730px;\n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-position: center;\n    background-size: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align:center;\n}\n\n.titleDiv{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 85px;\n    color: $baseWhite;\n\n}\n\n.quoteDiv{\n    background-color: $primaryOrange;\n    color:white;\n    height: 40px;\n    width: 203px;\n    font-size: 25px;\n    font-weight: 500;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.mainTitle{\n    font-size: 60px;\n    text-align: center;\n    color: $baseWhite;\n    background-color: $primaryOrange;\n    padding: 8px 24px;\n    margin: -24px;\n    margin-bottom: auto;\n}\n\n.weCare{\n    text-align:center;\n    display: flex;\n    flex-direction: column;\n    background-color: $primaryOrange;\n    color: $baseWhite;\n    position: absolute;\n    top: 710px;\n    font-weight: 500;\n    height: 55px;\n    padding:16px;\n    align-items: center;\n    justify-content: center;\n}\n\n@media (max-width: 425px){\n\n.headerDiv{\n    background-attachment: unset;\n    width: 231%;\n}\n\n.titleDiv{\n    padding: 60px;\n}\n\n.weCare{\n    width: 220%;\n    height: 59px;\n    top: 659px;\n    font-size: 17px;\n    left:12px;\n}\n\n\n}\n","$primaryOrange: #F27400;\n$secondaryBlue: #111E4B;\n$baseWhite: #FDFDFD;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
